// extracted by mini-css-extract-plugin
module.exports = {"createGroupTypeButtonContainer":"GroupType-tab_createGroupTypeButtonContainer_SiAyf"};